// 部署之後，開著舊分頁的人換頁會抓不到舊切塊：Pages 換成新 hash 的檔，舊 hash 的 404。
// Vite 在動態載入（路由元件、頁內延遲載入的元件）失敗時對 window 發 `vite:preloadError`；沒人接，
// 使用者看到的是點了沒反應或白畫面（2026-10-15 backlog P06）。
//
// 接法：第一次失敗就整頁重載（有換頁目標就直接載那一頁），重載後拿到新的 index.html 與新的切塊。
// 防無限重載：sessionStorage 記下重載的時間；RELOAD_WINDOW_MS 之內再失敗就不再重載，而且不 preventDefault，
// 讓 Vite 把錯誤照常拋出去（新部署的檔本身壞了，重載救不了，要看得到錯誤）。視窗過了才可以再救一次——
// 同一個分頁撐過兩次部署時，第二次也要救得回來。
// sessionStorage 不能讀寫（隱私模式、被擋）就不重載：沒有記號，一次失敗就可能變成無限重載。
// 自動化瀏覽器（預渲染的 Puppeteer）不接：建置要失敗就讓它失敗，不要被重載掩蓋。
export const RELOAD_MARK = 'cheyu:preload-reload'
export const RELOAD_WINDOW_MS = 30_000

function readMark(storage) {
  const value = storage.getItem(RELOAD_MARK)
  const time = Number(value)
  return value !== null && Number.isFinite(time) ? time : null
}

// 目標與當頁只差錨點時，assign 不會重載，要改用 reload()
const sameDocument = (target, href) => {
  try { return new URL(target, href).href.split('#')[0] === href.split('#')[0] } catch { return false }
}

export function installPreloadReload({ win = typeof window !== 'undefined' ? window : undefined, router, now = Date.now } = {}) {
  if (!win || win.navigator?.webdriver === true) return false
  let pending = null
  if (router) {
    router.beforeEach(to => { pending = to.fullPath })
    router.afterEach(() => { pending = null })
  }
  win.addEventListener('vite:preloadError', event => {
    let storage
    try {
      storage = win.sessionStorage
      const last = readMark(storage)
      if (last !== null && now() - last < RELOAD_WINDOW_MS) return
      storage.setItem(RELOAD_MARK, String(now()))
      if (readMark(storage) === null) return // 寫了讀不回來：等於沒有記號
    } catch {
      return
    }
    event.preventDefault()
    const href = win.location.href
    if (pending && !sameDocument(pending, href)) win.location.assign(pending)
    else win.location.reload()
  })
  return true
}
